export default __webpack_public_path__ + "static/media/forgottencitynormal.634284ce.jpg";